/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DiscountResultType = {
    BONUS_PRODUCT: 'BONUS_PRODUCT',
    FIXED_PRICE: 'FIXED_PRICE',
    MONEY_DISCOUNT: 'MONEY_DISCOUNT',
    PERCENT_DISCOUNT: 'PERCENT_DISCOUNT'
} as const;
export type DiscountResultType = typeof DiscountResultType[keyof typeof DiscountResultType];

